module.exports = __webpack_public_path__ + "img/ic-top-up-inprocess-emedia.f37e3ff3.svg";